















import CreateRoomForm from "@/home/CreateRoomForm.vue"

export default {
  name: 'HomeHeader',
  components: {CreateRoomForm}
}
